import { useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";

export default function SubjectAvatar(props) {
	const theme = useTheme();
	let { subject } = props;

	if (!subject?.name) {
		return;
	}

	const size = props?.size;
	let letter = subject.name.substring(0,1);
	const split = subject.name.split(' ');
	if( split.length == 2 ){
		letter = split[0].substring(0,1) + split[1].substring(0,1);
	}

	letter = letter.toUpperCase();

	const bgColour = subject.colour || '#555';
	const colour = theme.palette.getContrastText(bgColour);

	const sx ={ 
		border: 1, 
		borderColor: bgColour,
		height: size, 
		width: size, 
		fontSize: size * 0.5, 
		color: props.variant == 'outlined' ? bgColour : colour, 
		bgcolor: props.variant == 'outlined' ? 'initial' : bgColour
	};

	return (
		<Avatar title={subject.name} sx={sx}>
			{letter}
		</Avatar>
	);
}
